import promiseRetry from 'promise-retry'
import EventsAPI from '@/app/api/phq-public/events'
import * as R from 'ramda'
import moment from 'moment'

export const OVERFLOW_ERROR_CODE = 'EOVERFLOW'
export const COLUMN_ORDER = [
  'id', 'title', 'description', 'start', 'end', 'predicted_end', 'timezone', 'duration', 'category', 'labels',
  'country_code', 'geo_point', 'geo_polygon', 'geo_multipolygon', 'lat', 'lon', 'venue_id', 'venue_name', 'venue_formatted_address', 'scope', 'phq_rank', 'local_rank',
  'aviation_rank', 'phq_attendance', 'event_status', 'first_seen', 'updated',
]

const removeObjectKeys = function (keys, obj) {
  return keys.reduce((currentObj, key) => {
    return R.dissoc(key, currentObj)
  }, obj)
}

export const cleanApiParams = function (params) {
  const cleaned = removeObjectKeys(['getAllPages', 'token', 'count'], params)
  // https://github.com/predicthq/exporter-ui/issues/4
  if (cleaned.within) {
    cleaned.within = cleaned.within.replace(' ', '')
  }
  return cleaned
}

const getRangeMeta = ({start, end}) => {
  let length = 1
  let type = 'days'
  let diff = end.diff(start, 'day')
  if (diff > 365) {
    length = 365 // year
  } else if (diff > 30) {
    length = 30 // month
  } else if (diff > 7) {
    length = 7 // week
  } else if (diff <= 1) {
    // range is still 1
    type = 'hours'
    diff = end.diff(start, 'hour', true)
  }
  return {
    length,
    type,
    diff
  }
}

const getRange = (params, dateType, ltSuffix, gtSuffix) => {
  return {
    start: moment.utc(params[`${dateType}.${gtSuffix}`]),
    end: moment.utc(params[`${dateType}.${ltSuffix}`])
  }
}

export const getRangeChunks = (params, dateType, previousMeta, ltSuffix, gtSuffix) => {
  let range = getRange(params, dateType, ltSuffix, gtSuffix)
  let meta = getRangeMeta(range)
  if (meta.length === 1 && previousMeta.length === meta.length) {
    let error = Error('Your account event visibility limit is too low.')
    error.code = OVERFLOW_ERROR_CODE
    throw error
  }

  let wholeRanges = Math.floor(meta.diff / meta.length)
  const remainder = meta.diff - wholeRanges * meta.length

  if (remainder) {
    wholeRanges += 1
  }

  return {
    chunks: R.range(0, wholeRanges).map(index => {
      let gt = 'gt'
      let endAdd = meta.length
      if (remainder && (index === wholeRanges - 1)) {
        endAdd = remainder
        gt = gtSuffix
      }
      const start = moment(range.start).add(index * meta.length, meta.type)
      return {
        start: start,
        gt: gt,
        end: moment(start).add(endAdd, meta.type),
        lt: index === 0 ? ltSuffix : 'lte'
      }
    }),
    range: meta
  }
}

export const removeAllDateParams = (params) => {
  const dateParams = ['active', 'end', 'start']
  const suffixes = ['lt', 'lte', 'gt', 'gte']
  const possibleDateParams = []
  dateParams.map(date => {
    suffixes.map(suffix => {
      possibleDateParams.push(`${date}.${suffix}`)
    })
  })
  return Object.keys(params).reduce((acc, key) => {
    if (possibleDateParams.indexOf(key) === -1) {
      acc[key] = params[key]
    }
    return acc
  }, {})
}

export const getEventsPage = (params, token) => {
  return promiseRetry((retry) => {
    return EventsAPI.search(params, token).catch(retry)
  })
}

export const formatDateFilter = (dateFilter) => {
  return {
    type: dateFilter.type,
    gt: dateFilter.values.comparison_one.value,
    lt: dateFilter.values.comparison_two.value
  }
}
